<template>
  <md-drawer class="md-right" :md-active.sync="isShowDrawer" @md-closed="close">
    <md-list>
      <md-list-item v-if="this.$route.name !== 'SelectBox'">
        <md-button @click="selectBox"><i class="fa fa-search" aria-hidden="true"></i> 冷蔵庫ID入力</md-button>
      </md-list-item>
      <md-list-item>
        <md-button @click="commentList"><i class="fa fa-th-list" aria-hidden="true"></i> 配送員コメント一覧</md-button>
      </md-list-item>
      <md-list-item>
        <md-button @click="maintenanceCheck"><i class="fa fa-th-list" aria-hidden="true"></i> ロス・持ち帰り確認</md-button>
      </md-list-item>
      <hr>
      <md-list-item>
        <md-button @click="signOut"><i class="fa fa-sign-out" aria-hidden="true"></i> ログアウト</md-button>
      </md-list-item>
    </md-list>
  </md-drawer>
</template>


<script>
  export default {
    name: 'SidePanel',
    props: {
      isShowSidePanel: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      isShowSidePanel: function() {
        this.isShowDrawer = this.isShowSidePanel
      },
    },
    data() {
      return {
        isShowDrawer: this.isShowSidePanel,
      };
    },
    methods: {
      selectBox() {
        this.$emit('selectBox');
      },
      maintenanceCheck() {
        this.$emit('maintenanceList', 'MaintenanceCheck');
      },
      commentList() {
        this.$emit('maintenanceList', 'CommentList');
      },
      signOut() {
        this.$emit('signOut');
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style scoped>
  .md-drawer {
    z-index: 20;
  }
</style>



// WEBPACK FOOTER //
// src/components/globals/SidePanel.vue?4e215346